import React from 'react';
import './button.css';


export default ({icon, children, type}) => {
    return <button className={`btn ${getClassNames(type)}`}>
        <div className="children">{children}</div>
        {icon && <div className="icon">{icon()}</div>}
    </button>
}

const getClassNames = (type) => {
    switch(type) {
        case 'text':
            return 'btn-text';
        default:
            return 'btn-filled';
    }
}